<script setup lang="ts">
import { DefineComponent, SVGAttributes } from 'vue'
import { SPOT } from './../types.d'

const emits = defineEmits(['selected'])

type APP_LIST_PROPS = {
  checked: boolean
  name: string
  label: string
  showRadioInput?: boolean
  iconClasses?: string
  iconVariant?: string
  icon?: DefineComponent<SVGAttributes>
  capitalize?: boolean
  spot?: SPOT,
  isDesktop?: boolean
}

const props = withDefaults(defineProps<APP_LIST_PROPS>(), {
  showRadioInput: true,
  isDesktop: false
})

const handleSelected = () => {
  emits('selected', props)
}

const inputRef = ref<HTMLInputElement | null>(null)

const handleLabelClick = () => {
  if (inputRef.value) {
    inputRef.value.checked = true
    handleSelected()
  }
}
</script>

<template>
  <div :class="[
    'flex items-center transition-all duration-200',
    props.isDesktop === true ? 'gap-3 px-4 py-2.5 rounded-full border mb-2 cursor-pointer' : 'gap-2 px-4 py-3 last:border-0',
    {
      // desktop
      'bg-[#E3E6EC]': props.isDesktop === true && props.checked,
      'bg-white': props.isDesktop === true && !props.checked,
      'border-gray-200 hover:border-gray-300': props.isDesktop === true && !props.checked,

      // mobile
      'bg-[#EEF1F7]': props.isDesktop !== true && props.checked,
      'border-b border-brand-info': props.isDesktop !== true && !props.checked,
    },
    { capitalize: props.capitalize }
  ]">
    <input v-if="props.showRadioInput" :id="props.label" ref="inputRef"
      class="form-radio !m-0 h-4 w-4 cursor-pointer shadow !outline-none transition-all checked:!bg-brand-light checked:ring-1 checked:!ring-brand-light checked:ring-offset-2 hover:bg-[#EEEEEE] focus:bg-white focus:!ring-1 focus:!ring-brand-light focus:!ring-offset-[2px]"
      type="radio" :checked="props.checked" :name="props.name" @click="handleSelected()" />

    <Component :is="props.icon" v-if="props.icon" :class="props.iconClasses ?? 'w-4 fill-slate-800'" :style="{
      '--color-status': `hsl(var(--color-status-${props.iconVariant}))`,
    }" />

    <label class="font-normal text-black cursor-pointer" :class="{
      'w-52 truncate': spot,
    }" :for="props.label" @click.prevent="handleLabelClick">
      {{ props.label }}
    </label>
  </div>
</template>